export default __webpack_public_path__ + "static/day-7-cd8a2a273c38bc2bf43bbf57a65777fe.gif";